import * as React from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';
import Modal from 'react-bootstrap/Modal';

interface JobDetailsAddContactModalProps {
    customerId: number;
    id: number;
    showModal: boolean;
    hideModal(): void;
    saveModal(newContact: CustomerContactList): void;
}

interface AddContact {
    customerId: number;
    customerContactId: number;  //for editing
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;
    phone: string;
    emailSubscription: boolean;
}

interface CustomerContactList {
    id: number;
    customerId: number;
    name: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    mobile: string;
    emailSubscription: boolean;
}

const JobDetailsAddContactModalData = (props: JobDetailsAddContactModalProps) => {
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [addContact, setAddContact] = React.useState<AddContact>({
        customerId: props.customerId,
        customerContactId: -1,
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        phone: "",
        emailSubscription: true
    });
    const [saveDisabled, setSaveDisabled] = React.useState(false);


    React.useEffect(() => {
        if (props.id > 0) {
            setLoading(true);
            getData(props.id);
        } else {
            setLoading(false);
        }
    }, [props.id]);

    const getData = async (id: number) => {
        const token = await authService.getAccessToken();

        axios.get('api/Customer/GetCustomerContactById?Id=' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                setAddContact(res.data);
                setLoading(false);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const hideModal = () => {
        let resetContact = resetAddContact();
        setAddContact(resetContact);
        setErrors({});
        props.hideModal();
    }

    const handleAddContactChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errorList = errors;
        if (e.target.value) {
            delete errorList[e.target.name];
            setErrors(errorList);
        }

        setAddContact(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
        setSaveDisabled(false);
    }

    const validateAddContact = () => {
        let fields = addContact;
        let errorList: any = {};
        let formIsValid = true;

        if (!fields.firstName) {
            formIsValid = false;
            errorList["firstName"] = "First Name is required";
        }

        if (!fields.phone && !fields.mobile) {
            formIsValid = false;
            errorList["phone"] = "Phone or Mobile is required";
        }

        if (!fields.email) {
            formIsValid = false;
            errorList["email"] = "Email is required";
        } else if (fields.email.indexOf("@") < 0) {
            formIsValid = false;
            errorList["email"] = "Valid email is required";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const saveAddContact = () => {
        if (saveDisabled) {
            return;
        }

        setSaveDisabled(true);

        if (validateAddContact()) {
            addContactSave();
        }
    }

    const resetAddContact = () => {
        let resetContact: AddContact = {
            customerId: props.customerId,
            customerContactId: -1,
            firstName: "",
            lastName: "",
            email: "",
            mobile: "",
            phone: "",
            emailSubscription: true
        };

        return resetContact;
    }

    const addContactSave = async () => {
        const token = await authService.getAccessToken();

        var addEditContact: AddContact = {
            customerId: props.customerId,
            customerContactId: props.id,
            firstName: addContact.firstName,
            lastName: addContact.lastName,
            email: addContact.email,
            phone: addContact.phone,
            mobile: addContact.mobile,
            emailSubscription: addContact.emailSubscription
        };

        //add new contact
        axios.post('api/Customer/AddContact', addEditContact, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.messages.length == 0) {
                var newContact: CustomerContactList = {
                    id: res.data.id,
                    customerId: props.customerId,
                    name: res.data.name,
                    firstName: res.data.firstName,
                    lastName: res.data.lastName,
                    email: res.data.email,
                    phone: res.data.phone,
                    mobile: res.data.mobile,
                    emailSubscription: res.data.emailSubscription
                };

                let resetContact = resetAddContact();

                toast.success("Customer Contact Saved");
                setAddContact(resetContact);
                setErrors({});
                props.saveModal(newContact);
            } else {
                for (var i = 0; i < res.data.messages.length; i++) {
                    toast.error(res.data.messages[i].content);
                }
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const renderDetails = (
        <Modal static aria-labelledby="contained-modal-title-sm" show={props.showModal} onHide={hideModal}>
            <Modal.Header className="modal__header--colour">
                <Modal.Title>{props.id == 0 ? "Add New Contact" : "Edit Contact"}</Modal.Title>
                <button type="button" className="close" onClick={hideModal}>&times;</button>
            </Modal.Header>
            <Modal.Body>
                <div className={loading ? "hidden" : ""}>
                    <label className="input-group" htmlFor="firstName">
                        <span className="label">First Name</span>
                        <input className="input" type="text" id="firstName" name="firstName" value={addContact.firstName} onChange={(e) => handleAddContactChange(e)} disabled={props.id > 0}></input>
                    </label>
                    <span className="label errors">{errors["firstName"]}</span>

                    <label className="input-group" htmlFor="lastName">
                        <span className="label">Last Name</span>
                        <input className="input" type="text" id="lastName" name="lastName" value={addContact.lastName} onChange={(e) => handleAddContactChange(e)}></input>
                    </label>
                    <span className="label errors">{errors["lastName"]}</span>

                    <label className="input-group" htmlFor="email">
                        <span className="label">Email</span>
                        <input className="input" type="text" id="email" name="email" value={addContact.email} onChange={(e) => handleAddContactChange(e)}></input>
                    </label>
                    <span className="label errors">{errors["email"]}</span>

                    <label className="input-group" htmlFor="phone">
                        <span className="label">Phone</span>
                        <input className="input" type="text" id="phone" name="phone" value={addContact.phone} onChange={(e) => handleAddContactChange(e)}></input>
                    </label>
                    <span className="label errors">{errors["phone"]}</span>

                    <label className="input-group" htmlFor="mobile">
                        <span className="label">Mobile</span>
                        <input className="input" type="text" id="mobile" name="mobile" value={addContact.mobile} onChange={(e) => handleAddContactChange(e)}></input>
                    </label>
                </div>
                <div className={loading ? "" : "hidden"}>
                    Loading...
                </div>
                
            </Modal.Body>

            <Modal.Footer>
                <button className="popup-button--yes" onClick={saveAddContact} disabled={saveDisabled}>Save</button>
            </Modal.Footer>
        </Modal>
    )

    let contents = props.showModal
        ? renderDetails
        : <div></div>;

    return (
        <div>
            {contents}
        </div>
    )

}

export default JobDetailsAddContactModalData;